// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2qnvh","alert":"SettungsInbox_alert__2rgbI"};